module.exports = __webpack_public_path__ + "static/media/logo-supplied.7fcab8b9.png";